import {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router";
import {css} from "@panda/css";

import {CenterBox, Container} from "@pg-design/grid-module";
import {useModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

import {FullPageLoader} from "../../../components/loaders/FullPageLoader";
import {Modal} from "../../../components/modal/Modal";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {IUserProfile} from "../../user/interfaces/IUserProfile";
import {mailingUnsubscribeUser} from "../api/mailing_unsubscribe_user";
import {validateMailingUnsubscribeLink} from "../api/validate_mailing_unsubscribe_link";
import {ActivitySource} from "../constants/ActivitySource";
import {getSiteSlugFromActivitySource} from "../utils/get_site_slug_from_activity_source";

interface IProps {
    userProfile?: IUserProfile;
}

export const MailingUnsubscribeView = (props: IProps) => {
    const {userProfile} = props;
    const dispatch = useAppDispatch();
    const history = useHistory();
    const params = useParams<{emailHash: string; verificationHash: string; site: keyof typeof ActivitySource}>();

    const [email, setEmail] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const {shouldModalBeOpened: showModal, closeModal} = useModal({openedByDefault: true});

    useEffect(() => {
        const allowedSite = params.site && ActivitySource[params.site];

        // Only `rynekpierwotny` and `gethome` site params should be handled
        if (allowedSite) {
            validateMailingUnsubscribeLink(params.emailHash, params.verificationHash)
                .then((response) => {
                    if (userProfile) {
                        pushToMarketingConsentPage(ActivitySource[params.site]);
                        return;
                    }

                    if (!userProfile && response.email_marketing_consent) {
                        setEmail(response.email);

                        return;
                    }
                })
                .finally(() => setLoading(false));
        } else {
            pushToHomePage();
        }
    }, []);

    const onUnsubscribe = () => {
        setLoading(true);

        mailingUnsubscribeUser(params.emailHash, params.verificationHash, ActivitySource[params.site])
            .then(() => closeModal())
            .catch(() => dispatch(addNotification(defaultAPIErrorNotification)))
            .finally(() => setLoading(false));
    };

    const pushToHomePage = () => {
        history.push(kmAppLink.site.baseWithParams({site: SiteSlug.KM}));
    };

    const pushToMarketingConsentPage = (site: ActivitySource) => {
        const siteSlug = getSiteSlugFromActivitySource(site);
        history.push(kmAppLink.site.user.marketingConsentWithParams({site: siteSlug}));
    };

    if (loading) return <FullPageLoader />;

    return (
        <div>
            <Container>
                {showModal ? (
                    <FullPageLoader />
                ) : (
                    <CenterBox className={minHeightStyle}>
                        <Text variant="headline_0" mb={2}>
                            Przykro nam, że nas opuszczasz
                        </Text>
                        <Text variant="body_copy_0">
                            Szanujemy Twoje zdanie - nie będziemy już wysyłać wiadomości na adres <strong>{email}</strong>
                        </Text>
                    </CenterBox>
                )}
            </Container>

            <Modal isOpen={showModal} onModalClose={pushToHomePage} className={modalStyle}>
                <Modal.Layout.ConfirmCentered
                    title="Czy na pewno chcesz usunąć swój adres e‑mail z naszej bazy?"
                    onConfirmation={onUnsubscribe}
                    onCancel={pushToHomePage}
                    okButtonText="Tak"
                    cancelButtonText="Nie"
                />
            </Modal>
        </div>
    );
};

const minHeightStyle = css({
    minHeight: "100vh"
});

const modalStyle = css({
    md: {
        maxWidth: "66rem"
    }
});
import {useEffect, useState} from "react";
import {useHistory, useParams} from "react-router";
import {css} from "@panda/css";

import {CenterBox, Container} from "@pg-design/grid-module";
import {useModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {kmAppLink, SiteSlug} from "@pg-mono/km-routes";

import {FullPageLoader} from "../../../components/loaders/FullPageLoader";
import {Modal} from "../../../components/modal/Modal";
import {useAppDispatch} from "../../../store/hooks/use_app_dispatch";
import {addNotification} from "../../notifications/state/notifications_slice";
import {defaultAPIErrorNotification} from "../../notifications/utils/error_notifications";
import {IUserProfile} from "../../user/interfaces/IUserProfile";
import {mailingUnsubscribeUser} from "../api/mailing_unsubscribe_user";
import {validateMailingUnsubscribeLink} from "../api/validate_mailing_unsubscribe_link";
import {ActivitySource} from "../constants/ActivitySource";
import {getSiteSlugFromActivitySource} from "../utils/get_site_slug_from_activity_source";

interface IProps {
    userProfile?: IUserProfile;
}

export const MailingUnsubscribeView = (props: IProps) => {
    const {userProfile} = props;
    const dispatch = useAppDispatch();
    const history = useHistory();
    const params = useParams<{emailHash: string; verificationHash: string; site: keyof typeof ActivitySource}>();

    const [email, setEmail] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const {shouldModalBeOpened: showModal, closeModal} = useModal({openedByDefault: true});

    useEffect(() => {
        const allowedSite = params.site && ActivitySource[params.site];

        // Only `rynekpierwotny` and `gethome` site params should be handled
        if (allowedSite) {
            validateMailingUnsubscribeLink(params.emailHash, params.verificationHash)
                .then((response) => {
                    if (userProfile) {
                        pushToMarketingConsentPage(ActivitySource[params.site]);
                        return;
                    }

                    if (!userProfile && response.email_marketing_consent) {
                        setEmail(response.email);

                        return;
                    }
                })
                .finally(() => setLoading(false));
        } else {
            pushToHomePage();
        }
    }, []);

    const onUnsubscribe = () => {
        setLoading(true);

        mailingUnsubscribeUser(params.emailHash, params.verificationHash, ActivitySource[params.site])
            .then(() => closeModal())
            .catch(() => dispatch(addNotification(defaultAPIErrorNotification)))
            .finally(() => setLoading(false));
    };

    const pushToHomePage = () => {
        history.push(kmAppLink.site.baseWithParams({site: SiteSlug.KM}));
    };

    const pushToMarketingConsentPage = (site: ActivitySource) => {
        const siteSlug = getSiteSlugFromActivitySource(site);
        history.push(kmAppLink.site.user.marketingConsentWithParams({site: siteSlug}));
    };

    if (loading) return <FullPageLoader />;

    return (
        <div>
            <Container>
                {showModal ? (
                    <FullPageLoader />
                ) : (
                    <CenterBox className={minHeightStyle}>
                        <Text variant="headline_0" mb={2}>
                            Przykro nam, że nas opuszczasz
                        </Text>
                        <Text variant="body_copy_0">
                            Szanujemy Twoje zdanie - nie będziemy już wysyłać wiadomości na adres <strong>{email}</strong>
                        </Text>
                    </CenterBox>
                )}
            </Container>

            <Modal isOpen={showModal} onModalClose={pushToHomePage} className={modalStyle}>
                <Modal.Layout.ConfirmCentered
                    title="Czy na pewno chcesz usunąć swój adres e‑mail z naszej bazy?"
                    onConfirmation={onUnsubscribe}
                    onCancel={pushToHomePage}
                    okButtonText="Tak"
                    cancelButtonText="Nie"
                />
            </Modal>
        </div>
    );
};

const minHeightStyle = css({
    minHeight: "100vh"
});

const modalStyle = css({
    md: {
        maxWidth: "66rem"
    }
});
